import { render, staticRenderFns } from "./documentDialog.vue?vue&type=template&id=97dd8f7c"
import script from "./documentDialog.vue?vue&type=script&lang=js"
export * from "./documentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports